import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "input", "submit"]

  connect() {
    this.refresh()
  }

  select(event) {
    const card = event.currentTarget
    this.inputTarget.value = card.dataset.role
    this.refresh()
  }

  refresh() {
    const value = this.inputTarget.value
    this.cardTargets.forEach((card) => {
      card.classList.toggle("is-selected", card.dataset.role === value)
    })
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = value === ""
    }
  }
}
